import { isNode } from "@use/is-node";

/**
 * Wrapper around setInterval that strongly types returned value.
 */
export function setInterval(handler: () => unknown, timeout: number = 0): NodeJS.Timeout | number {
    return (
        isNode()
            ? global.setInterval(handler, timeout)
            : window.setInterval(handler, timeout)
    );
}
